import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../img/2solve.svg";
import LogoCurta from "../../img/2s.svg";
import "./sidebar-stylesheet.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function Sidebar({ toggleSidebar, sidebarOpen }) {
  const { t } = useTranslation();

  const location = useLocation();

  useEffect(() => {
    const handleWindowResize = () => {
      if (window.innerWidth < 768) {
        toggleSidebar(false);
      }
    };

    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, [toggleSidebar]);

  const isActive = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const handleLinkClick = () => {
    if (window.innerWidth < 768 && sidebarOpen) {
      toggleSidebar(false);
    }
  };

  const routeNames = {
    "/": t("Home"),
    "/ativos": t("Ativos"),
    "/usuarios": t("Usuários"),
  };

  return (
    <>
      <Navbar className={`col-3 sidebar ${sidebarOpen ? "" : "collapsed"}`}>
        <Navbar.Collapse id="sidebar-nav" className="col-3">
          <br />
          <div className="sidebar-texto">
            <div className="sidebar-filhos">
              <Link
                to="/"
                className={`rota sidebar-filho ${
                  isActive("/") ? "pagatual" : ""
                }`}
                onClick={handleLinkClick}
              >
                <p className="sidebar-dropdown-texto">
                  <i className="bi bi-grid-1x2 sidebar-icon" /> {t("Home")}
                </p>
              </Link>
              <Link
                to="/ativos"
                className={`rota sidebar-filho ${
                  isActive("/ativos") ? "pagatual" : ""
                }`}
                onClick={handleLinkClick}
              >
                <p className="sidebar-dropdown-texto">
                  <i className="bi tubo-icon-expand sidebar-icon" />
                  {t("Ativos")}
                </p>
              </Link>

              <Link
                to="/usuarios"
                className={`rota sidebar-filho ${
                  isActive("/usuarios") ? "pagatual" : ""
                }`}
                onClick={handleLinkClick}
              >
                <p className="sidebar-dropdown-texto">
                  <i className="bi bi-person sidebar-icon" /> {t("Usuários")}
                </p>
              </Link>
            </div>
          </div>
          <div className="sidebar-filhos-recolhido">
            {Object.keys(routeNames).map((path) => (
              <OverlayTrigger
                key={path}
                placement="right"
                delay={{ show: 10 }}
                overlay={
                  <Tooltip id={`tooltip-${path}`}>{routeNames[path]}</Tooltip>
                }
              >
                <Link
                  to={path}
                  className={`rota ${
                    sidebarOpen ? "hide" : "btn-menu-recolhido"
                  } ${isActive(path) ? "pagatual-icn" : ""}`}
                  onClick={handleLinkClick}
                >
                  <i
                    className={`bi ${getIconClass(path)} ${
                      sidebarOpen ? "hide" : "show"
                    }`}
                  />
                </Link>
              </OverlayTrigger>
            ))}
          </div>
          <Button
            title="Fechar sidebar"
            onClick={() => {
              toggleSidebar();
            }}
            className={`toggle-sidebar-button btn-menu-fechado collapsed${
              sidebarOpen ? "hide" : ""
            }`}
          >
            <i
              className={`bi btn-menu-icn ${
                sidebarOpen ? "bi-caret-left" : "bi-caret-right"
              }`}
            ></i>
          </Button>
          <div className="sidebar-filhos sidebar-img">
            <img
              src={sidebarOpen ? Logo : LogoCurta}
              alt={sidebarOpen ? "Logo 2S" : "Logo 2S"}
              className={` ${
                sidebarOpen ? "sidebar-logo" : "img-sidebar-short"
              }`}
              width="100%"
              height="100%"
            />
          </div>
        </Navbar.Collapse>
      </Navbar>
    </>
  );

  function getIconClass(path) {
    switch (path) {
      case "/":
        return "bi-grid-1x2";
      case "/alarmes/dashboard/temporeal":
        return "bi-exclamation-triangle";
      case "/variaveis":
        return "bi-type";
      case "/ativos":
        return "tubo-icon";
      case "/alarmes-cadastro":
        return "bi-clock";
      case "/usuarios":
        return "bi-person-circle";
      case "/relatorios":
        return "bi-journal-text";
      case "/forecast":
        return "bi-graph-up-arrow";
      default:
        return "";
    }
  }
}
Sidebar.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
};

export default Sidebar;
